import {collection, EntityData, field, identifier, LocalisableEntityData} from "@fedeltapointofsale/data-client";
import {AbstractBIPageData} from "../bi-page/bi-page.data";

export class DashboardChartData extends EntityData<DashboardChartData> {
    @identifier id: number;
    @field title: string;
    @field chartType: string;
    @collection() filterMembers: string[];
    @field attribute: string;
    @field selectedAttribute: string;
    @collection() measures: string[];
    @collection() selectedMeasures: string[];
    @field selectedRefLine: string;
    @field topCount: number;
    @field topBottomRef: string;
    @field hideZero: boolean;
    @field pinLevel: boolean;
    @field layoutRow: number;
    @field layoutCol: number;

    get xAxisLabel(): string {
        return this.selectedAttribute ? this.selectedAttribute.replace(/.*\[(.*)]$/, "$1") : undefined;
    }

    hasChartData(): boolean {
        return !!this.attribute ||
            !!this.selectedAttribute ||
            (this.measures && this.measures.length != 0) ||
            (this.selectedMeasures && this.selectedMeasures.length != 0) ||
            (this.filterMembers && this.filterMembers.length != 0);
    }
}

export class DashboardData extends AbstractBIPageData<DashboardData> {
    @collection() filterMembers: string[];
    @collection(DashboardChartData) charts: DashboardChartData[];
}
